import { AsButton, Spacer } from '@adserve/adserve-react-components';
import React, { useEffect, useState } from 'react';
import AsSelectWithPlaceholder from '../../generic/AsSelectWithPlaceholder';

const CopyTypeHeaderRow = ({
    campaignId,
    staticData,
    onAddCopyType,
    campaign,
    readOnly
}) => {
    const findStandardAirTime = () => {
        const spotType = staticData?.spotTypes?.find((x) => x.isDefault);
        return spotType?.id;
    };

    const [spotType, setSpotType] = useState(findStandardAirTime());
    const [selectedScript, setSelectedScript] = useState({});
    const [scriptInfo, setScriptInfo] = useState({
        scriptLength1: 30,
        scriptLength2: 0,
        scriptLength3: 0,
        positionInBreak1: 'Any',
        positionInBreak2: 'Any',
        positionInBreak3: 'Any'
    });

    const positionInBreakEnum = {
        FIRST: 'First',
        ANY: 'Any',
        LAST: 'Last'
    };

    const headerCellStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        border: '1px solid #E3E3E3'
    };

    const headerFontStyle = {
        fontSize: 15,
        fontWeight: 500,
        textAlign: 'center'
    };

    const headerInputStyle = {
        width: 128,
        height: 32,
        padding: 'none',
        paddingLeft: 10,
        fontSize: 14,
        fontWeight: 600
    };

    const setScriptLength1 = (v) => {
        const value = v === -1 ? 0 : v;
        setScriptInfo({
            ...scriptInfo,
            scriptLength1: value,
            positionInBreak1: '',
            scriptLength2: 0,
            positionInBreak2: '',
            scriptLength3: 0,
            positionInBreak3: ''
        });
    };
    const setScriptLength2 = (v) => {
        const value = v === -1 ? 0 : v;
        setScriptInfo({
            ...scriptInfo,
            scriptLength2: value,
            positionInBreak2: '',
            scriptLength3: 0,
            positionInBreak3: ''
        });
    };
    const setScriptLength3 = (v) => {
        const value = v === -1 ? 0 : v;
        setScriptInfo({
            ...scriptInfo,
            scriptLength3: value,
            positionInBreak3: ''
        });
    };

    const setPositionInBreak1 = (v) => {
        setScriptInfo({
            ...scriptInfo,
            positionInBreak1: v,
            scriptLength2: 0,
            positionInBreak2: '',
            scriptLength3: 0,
            positionInBreak3: ''
        });
    };
    const setPositionInBreak2 = (v) => {
        setScriptInfo({
            ...scriptInfo,
            positionInBreak2: v,
            scriptLength3: 0,
            positionInBreak3: ''
        });
    };
    const setPositionInBreak3 = (v) => {
        setScriptInfo({ ...scriptInfo, positionInBreak3: v });
    };

    const setScriptFactors = () => {
        staticData?.scriptFactors?.map((a, b) => {
            let mask = '*';
            if (a.scriptLengthFirst) mask += 'F=' + a.scriptLengthFirst;
            if (a.scriptLength) mask += 'N=' + a.scriptLength;
            if (a.scriptLengthLast) mask += 'L=' + a.scriptLengthLast;

            if (a.scriptLengthFirst) {
                a.script1 = a.scriptLengthFirst;
                a.position1 = 'First';
                a.position1Id = positionInBreakEnum.FIRST;
                if (a.scriptLength) {
                    a.script2 = a.scriptLength;
                    a.position2 = 'Any';
                    a.position2Id = positionInBreakEnum.ANY;
                    if (a.scriptLengthLast) {
                        a.script3 = a.scriptLengthLast;
                        a.position3 = 'Last';
                        a.position3Id = positionInBreakEnum.LAST;
                    }
                } else {
                    if (a.scriptLengthLast) {
                        a.script2 = a.scriptLengthLast;
                        a.position2 = 'Last';
                        a.position2Id = positionInBreakEnum.LAST;
                    }
                }
            } else if (a.scriptLength) {
                a.script1 = a.scriptLength;
                a.position1 = 'Any';
                a.position1Id = positionInBreakEnum.ANY;
                if (a.scriptLenthLast) {
                    a.script2 = a.scriptLengthLast;
                    a.position2 = 'Last';
                    a.position2Id = positionInBreakEnum.LAST;
                }
            } else {
                a.script1 = a.scriptLengthLast;
                a.position1 = 'Last';
                a.position1Id = positionInBreakEnum.LAST;
            }
            a.mask = mask;
            return true;
        });
    };

    useEffect(() => {
        // Filter the position in break and scripts for each dropdown to those where selected value exists
        setScriptFactors();
        getSelectedScript();
    }, [scriptInfo]);

    const validScripts = (position) => {
        const lengths = [];

        staticData?.scriptFactors?.map((a) => {
            if (!a.script1) return false;
            if (position === 1) {
                lengths[a.script1] = {
                    id: a.script1,
                    name: a.script1
                };
            }

            if (position === 2) {
                if (
                    a.script1 === scriptInfo.scriptLength1 &&
                    a.position1 === scriptInfo.positionInBreak1 &&
                    a.script2
                ) {
                    lengths[a.script2] = {
                        id: a.script2,
                        name: a.script2
                    };
                }
            }
            if (position === 3) {
                if (
                    a.script1 === scriptInfo.scriptLength1 &&
                    a.position1 === scriptInfo.positionInBreak1 &&
                    a.script2 === scriptInfo.scriptLength2 &&
                    a.position2 === scriptInfo.positionInBreak2 &&
                    a.script3
                ) {
                    lengths[a.script3] = {
                        id: a.script3,
                        name: a.script3
                    };
                }
            }
            return true;
        });

        return Object.values(lengths);
    };
    const validPositions = (position) => {
        const positions = [];
        if (position === 2 && !scriptInfo.scriptLength1) return positions;
        if (position === 3 && !scriptInfo.scriptLength2) return positions;
        staticData?.scriptFactors?.map((a, b) => {
            if (position === 1)
                if (a.script1 === scriptInfo.scriptLength1)
                    positions[a.position1Id] = {
                        id: a.position1Id,
                        name: a.position1
                    };

            if (
                position === 2 &&
                scriptInfo.scriptLength1 &&
                scriptInfo.positionInBreak1 &&
                a.script2
            )
                if (
                    a.script1 === scriptInfo.scriptLength1 &&
                    a.position1 === scriptInfo.positionInBreak1 &&
                    a.script2 === scriptInfo.scriptLength2
                ) {
                    if (a.position2Id)
                        positions[a.position2Id] = {
                            id: a.position2Id,
                            name: a.position2
                        };
                }

            if (
                position === 3 &&
                scriptInfo.scriptLength1 &&
                scriptInfo.scriptLength2 &&
                scriptInfo.positionInBreak1 &&
                scriptInfo.positionInBreak2 &&
                scriptInfo.scriptLength3
            )
                if (
                    a.script1 === scriptInfo.scriptLength1 &&
                    a.position1 === scriptInfo.positionInBreak1 &&
                    a.script2 === scriptInfo.scriptLength2 &&
                    a.position2 === scriptInfo.positionInBreak2 &&
                    a.script3 === scriptInfo.scriptLength3
                ) {
                    if (a.position3Id)
                        positions[a.position3Id] = {
                            id: a.position3Id,
                            name: a.position3
                        };
                }

            return true;
        });

        return Object.values(positions);
    };

    const getSelectedScript = () => {
        // Filters Script Factors to show possible ScriptFactors base on selected 
        const filterScripts = staticData?.scriptFactors?.filter((a) => {
            let isGood1 = true;
            let isGood2 = true;
            let isGood3 = true;

            if (scriptInfo.scriptLength1)
                isGood1 =
                    a.script1 === scriptInfo.scriptLength1 &&
                    (!scriptInfo.positionInBreak1 ||
                        scriptInfo.positionInBreak1 === a.position1);
            if (scriptInfo.scriptLength2)
                isGood2 =
                    a.script2 === scriptInfo.scriptLength2 &&
                    (!scriptInfo.positionInBreak2 ||
                        scriptInfo.positionInBreak2 === a.position2);
            if (scriptInfo.scriptLength3)
                isGood3 =
                    a.script3 === scriptInfo.scriptLength3 &&
                    (!scriptInfo.positionInBreak3 ||
                        scriptInfo.positionInBreak3 === a.position3);

            return isGood1 && isGood2 && isGood3;
        });

        if (filterScripts?.length === 1) {
            const script = filterScripts[0];

            const newInfo = {
                scriptLength1: script.position1 === 'First' 
                    ? script.scriptLengthFirst 
                    : script.position1 === 'Last' 
                        ? script.scriptLengthLast 
                        : script.scriptLength ?? 0,
                scriptLength2: script.position2 === 'Any' 
                    ? script.scriptLength 
                    : script.position2 === 'Last' 
                        ? script.scriptLengthLast 
                        : 0,
                scriptLength3: script.position3 !== undefined ? script.scriptLengthLast ?? 0 : 0,
                positionInBreak1: script.position1 ?? '',
                positionInBreak2: script.position2 ?? '',
                positionInBreak3: script.position3 ?? ''
            };

            if (JSON.stringify(newInfo) !== JSON.stringify(scriptInfo)) {
                setScriptInfo(newInfo);
            }

            setSelectedScript(script);
        } else {
            // Filters Script Factors to show only ScriptFactors base on selected 
            const scriptSelect = filterScripts?.filter((a) => {
                let isGood1 = false;
                let isGood2 = false;
                let isGood3 = false;

                isGood1 = scriptInfo.positionInBreak1 === a.position1 && (scriptInfo.scriptLength1 === a.scriptLength || scriptInfo.scriptLength1 === a.scriptLengthFirst);

                isGood2 =
                    ((scriptInfo.positionInBreak2 === '' || scriptInfo.positionInBreak2 === a.position2) && (scriptInfo.scriptLength2 === a.scriptLength || scriptInfo.scriptLength2 === (a.scriptLengthLast ?? 0)));

                isGood3 =
                    ((scriptInfo.positionInBreak3 === '' || scriptInfo.positionInBreak3 === a.position3) && scriptInfo.scriptLength3 === (a.scriptLengthLast ?? 0));

                return isGood1 && isGood2 && isGood3;
            });

            if (scriptSelect?.length === 1) {
                const script = scriptSelect[0];
                setSelectedScript(script);
            }
            else {
                setSelectedScript();
            }

        }
    };

    const resetHeader = () => {
        setSpotType(findStandardAirTime());
        setScriptInfo({
            scriptLength1: 30,
            scriptLength2: 0,
            scriptLength3: 0,
            positionInBreak1: '',
            positionInBreak2: '',
            positionInBreak3: ''
        });
    };
    const handleAddClick = () => {
        const newCopyType = {
            campaignId,
            spotTypeId: spotType,
            scriptFactorId: selectedScript.id
        };

        resetHeader();
        if (onAddCopyType) {
            onAddCopyType(newCopyType);
        }
    };

    const canAdd = () => {
        const candidateScript = selectedScript;
        if (!candidateScript) {
            return false;
        }

        const existingScripts = campaign?.copyTypes?.find(
            (s) =>
                s.spotTypeId === spotType &&
                s.scriptFactorId === candidateScript.id
        );

        if (existingScripts) {
            return false;
        }
        return true;
    };

    return (
        <>
            <div
                style={{
                    ...headerCellStyle,
                    width: 270
                }}
            >
                <span style={headerFontStyle}>
                    {window.translate('Spot Type')}
                </span>
                <div style={{ alignSelf: 'flex-end', paddingRight: 10 }}>
                    <AsSelectWithPlaceholder
                        id='spot-type'
                        name='spotTypeId'
                        values={staticData.spotTypes.filter(spotType => spotType.displayInSpotRules)}
                        value={spotType}
                        inputStyle={{ ...headerInputStyle, width: 200 }}
                        onChange={(e) => setSpotType(e.target.value)}
                        disabled={readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
            </div>
            <Spacer width={29} />
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        ...headerCellStyle,
                        width: 148,
                        backgroundColor: '#FBFBFB'
                    }}
                >
                    <span style={headerFontStyle}>
                        {window.translate('Script Length')}
                    </span>
                    <AsSelectWithPlaceholder
                        id='script-length-first'
                        name='scriptFactorId'
                        values={validScripts(1)}
                        value={scriptInfo.scriptLength1}
                        displayFieldName='scriptLength'
                        inputStyle={headerInputStyle}
                        onChange={(e) =>
                            setScriptLength1(parseInt(e.target.value))
                        }
                        disabled={readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
                <div
                    style={{
                        ...headerCellStyle,
                        width: 148
                    }}
                >
                    <span style={headerFontStyle}>
                        {window.translate('Position in break')}
                    </span>
                    <AsSelectWithPlaceholder
                        values={validPositions(1)}
                        value={scriptInfo.positionInBreak1}
                        inputStyle={headerInputStyle}
                        onChange={(e) => setPositionInBreak1(e.target.value)}
                        disabled={readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
            </div>
            <Spacer width={29} />
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        ...headerCellStyle,
                        width: 148,
                        backgroundColor: '#FBFBFB'
                    }}
                >
                    <span style={headerFontStyle}>
                        {window.translate('Script Length')}
                    </span>
                    <AsSelectWithPlaceholder
                        values={validScripts(2)}
                        value={scriptInfo.scriptLength2}
                        inputStyle={headerInputStyle}
                        onChange={(e) =>
                            setScriptLength2(parseInt(e.target.value))
                        }
                        disabled={validScripts(2).length === 0 || readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
                <div
                    style={{
                        ...headerCellStyle,
                        width: 148
                    }}
                >
                    <span style={headerFontStyle}>
                        {window.translate('Position in break')}
                    </span>
                    <AsSelectWithPlaceholder
                        values={validPositions(2)}
                        value={scriptInfo.positionInBreak2}
                        inputStyle={headerInputStyle}
                        onChange={(e) => setPositionInBreak2(e.target.value)}
                        disabled={validScripts(2).length === 0 || readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
            </div>
            <Spacer width={29} />
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        ...headerCellStyle,
                        width: 148,
                        backgroundColor: '#FBFBFB'
                    }}
                >
                    <span style={headerFontStyle}>
                        {window.translate('Script Length')}
                    </span>
                    <AsSelectWithPlaceholder
                        values={validScripts(3)}
                        value={scriptInfo.scriptLength3}
                        inputStyle={headerInputStyle}
                        onChange={(e) =>
                            setScriptLength3(parseInt(e.target.value))
                        }
                        disabled={validScripts(3).length === 0 || readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
                <div
                    style={{
                        ...headerCellStyle,
                        width: 148
                    }}
                >
                    <span style={headerFontStyle}>
                        {window.translate('Position in break')}
                    </span>
                    <AsSelectWithPlaceholder
                        values={validPositions(3)}
                        value={scriptInfo.positionInBreak3}
                        inputStyle={headerInputStyle}
                        onChange={(e) => setPositionInBreak3(e.target.value)}
                        disabled={validScripts(3).length === 0 || readOnly}
                        disabledStyle={{ color: '#919191' }}
                    />
                </div>
            </div>
            <Spacer width={29} />
            <div
                style={{
                    ...headerCellStyle,
                    width: 107,
                    backgroundColor: '#FBFBFB'
                }}
            >
                <span
                    style={{
                        ...headerFontStyle,
                        marginTop: 25,
                        marginRight: 15
                    }}
                >
                    {window.translate('% Ratio')}
                </span>
            </div>

            <AsButton
                style={{
                    width: 120,
                    marginLeft: 20,
                    marginTop: 30,
                    fontSize: 15,
                    fontWeight: 'bold'
                }}
                disabled={!canAdd() || readOnly}
                handleClick={handleAddClick}
            >
                {window.translate('Add')}
            </AsButton>
        </>
    );
};

export default CopyTypeHeaderRow;